import { notification } from "antd";
import { publicAPI } from "../../Config/Constant";
import store from "../store";


export const getLoginTemplate = async (payload) => {
  try {
    const res = await publicAPI.get(
      `/campaignLoginTemplate/get/${payload.organizationid}?page=payload.page`

    );

    if (res) {


      if (res) {
        store.dispatch({
          type: "SET_ALL_LOGIN_TEMPLATE",
          payload: res.data.data,
        });

        return res;
        // }
      }
    }
  } catch (err) {
    //    console.error('Error during login:', err);
    notification.error({
      message: err?.response?.data?.message || "Server Error",
      duration: 3,
    });
  }
};



export const getSingleLoginTemplate = async (payload) => {
  try {
    const res = await publicAPI.get(
`/campaignLoginTemplate/get-single/${payload.id}?page=payload.page`

    );

    if (res) {

      if (res) {
        store.dispatch({
          type: "SET_ALL_LOGIN_SINGLE_TEMPLATE",
          payload: res.data.data,
        });

        return res;
        // }
      }
    }
  } catch (err) {
    //    console.error('Error during login:', err);
    notification.error({
      message: err?.response?.data?.message || "Server Error",
      duration: 3,
    });
  }
};
